import { render, staticRenderFns } from "./Wxpay.vue?vue&type=template&id=5037091d&scoped=true&"
import script from "./Wxpay.vue?vue&type=script&lang=js&"
export * from "./Wxpay.vue?vue&type=script&lang=js&"
import style0 from "./Wxpay.vue?vue&type=style&index=0&id=5037091d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5037091d",
  null
  
)

export default component.exports